module.exports = __webpack_public_path__ + "0e672a69e40a59f04b4821dbf4d8c437.pdf";